import React from "react";
import "./WhyChooseUs.css";

// Yahan humne images ko aapke assets folder se import kiya hai
import heroBanner from "../../assets/images/bn2.png";
import sideImage from "../../assets/images/p4.jpeg";

const WHY_CHOOSE_DATA = [
  {
    number: "01",
    title: "Science-based formulations",
    description:
      "Developed through rigorous scientific research and verified testing in Chemistry Research Laboratories.",
  },
  {
    number: "02",
    title: "Premium active ingredients",
    description:
      "Carefully selected natural compounds combined with clinically recognized actives for real results.",
  },
  {
    number: "03",
    title: "Suitable for all skin types",
    description:
      "Formulated to be gentle, non-irritating, and effective for everyday self-care.",
  },
  {
    number: "04",
    title: "Lightweight and non-greasy formulations",
    description:
      "Fast-absorbing textures that provide deep hydration without feeling heavy or blocking pores.",
  },
  {
    number: "05",
    title: "High-quality manufacturing standards",
    description:
      "Produced under strict quality control to guarantee safety, quality, and consistency.",
  },
  {
    number: "06",
    title: "Customer-focused service",
    description:
      "Dedicated support and skincare guidance tailored to your personal goals and skin journey.",
  },
  {
    number: "07",
    title: "Continuous research and innovation",
    description:
      "Always researching to bring you the latest breakthroughs in science-backed skincare.",
  },
];

const WhyChooseUs = () => {
  return (
    <div className="why-choose-page-wrapper">

      {/* =====================================================
          HERO (Background Image: bn2.png)
      ===================================================== */}
      <section
        className="why-choose-hero-section"
        style={{
          // Import ki hui image ko yahan use kiya hai
          backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${heroBanner})`,
        }}
      >
        <div className="why-choose-hero-content">
          <h1 className="why-choose-hero-title">
            WHY CHOOSE US
          </h1>
          <p className="why-choose-hero-subtitle">
            Science-backed Skincare Excellence
          </p>
        </div>
      </section>

      {/* =====================================================
          WHY YOURCARE SECTION
      ===================================================== */}
      <section className="why-choose-main-section">
        <div className="why-choose-content-container">

          {/* LEFT CONTENT */}
          <div className="why-choose-list-section">
            <span className="why-choose-section-label">
              WHY YOURCARE
            </span>
            <h2 className="why-choose-main-title">
              Why Choose YourCare?
            </h2>

            {/* TIMELINE */}
            <div className="why-choose-timeline">
              <div className="why-choose-timeline-line"></div>

              {WHY_CHOOSE_DATA.map((item) => (
                <div
                  className="why-choose-timeline-item"
                  key={item.number}
                >
                  {/* DOT */}
                  <div className="why-choose-timeline-dot">
                    <span></span>
                  </div>

                  {/* CONTENT */}
                  <div className="why-choose-item-content">
                    <span className="why-choose-item-number">
                      {item.number}
                    </span>
                    <h3 className="why-choose-item-title">
                      {item.title}
                    </h3>
                    <p className="why-choose-item-description">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE (Image: p4.jpeg) */}
          <div className="why-choose-image-section">
            <div className="why-choose-image-wrapper">
              <img
                src={sideImage} // Import ki hui p4.jpeg image ko yahan lagaya hai
                alt="YourCare skincare serum"
                className="why-choose-main-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          BOTTOM BRAND STATEMENT
      ===================================================== */}
      <section className="why-choose-bottom-section">
        <div className="why-choose-bottom-content">
          <span className="why-choose-bottom-label">
            YOUR CARE
          </span>
          <h2>
            Science, Care &amp; Confidence
          </h2>
          <p>
            At YourCare, every formulation is created with a commitment
            to quality, research, innovation, and your everyday skincare
            needs.
          </p>
        </div>
      </section>

    </div>
  );
};

export default WhyChooseUs;